import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { DisclaimerGate } from "./components/Disclaimer";
import { Toaster } from "sonner";
import "@/App.css";
import "@/styles/phase2.css";
import { api, setToken } from "./lib/api";
import { Loading, Shell } from "./components/Shell";
import { Certifications, Detail, Home } from "./pages/Public";
import { About, Contact, Faq, NotFound, Privacy, Refund, Terms } from "./pages/Legal";
import { Auth, AuthCallback, ResetPassword } from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Assessment from "./pages/Assessment";
import { Certificate, Verify } from "./pages/Certificates";
import Admin from "./pages/admin/Admin";

const AdminDenied = ({ user, setUser }) => {
  const location = useLocation();
  const logged = useRef("");
  useEffect(() => {
    if (logged.current === location.pathname) return;
    logged.current = location.pathname;
    api.post("/security/admin-probe", { path: location.pathname }).catch(() => {});
  }, [location.pathname]);
  return user ? <Navigate to="/dashboard" replace /> : <Auth setUser={setUser} />;
};

function AppRouter() {
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setChecked(true); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setToken(null)).finally(() => setChecked(true));
  }, []);
  if (location.hash?.includes("session_id=")) return <AuthCallback setUser={setUser} />;
  const gate = (el) => (!checked ? <Loading label="Checking your session…" /> : user ? el : <Auth setUser={setUser} />);
  const adminGate = (el) => (!checked ? <Loading label="Checking your session…" /> : user?.role === "admin" ? el : <AdminDenied user={user} setUser={setUser} />);
  return (
    <Shell user={user} setUser={setUser}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/certifications" element={<Certifications />} />
        <Route path="/certifications/:slug" element={<Detail user={user} />} />
        <Route path="/login" element={<Auth setUser={setUser} />} />
        <Route path="/dashboard" element={gate(<Dashboard user={user} />)} />
        <Route path="/assessment/:slug" element={gate(<Assessment />)} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/certificate/:id" element={<Certificate />} />
        <Route path="/admin/*" element={adminGate(<Admin user={user} />)} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refund-policy" element={<Refund />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <DisclaimerGate />
    </Shell>
  );
}

export default function App() {
  return <BrowserRouter><AppRouter /><Toaster position="bottom-right" richColors /></BrowserRouter>;
}
